import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { me } from 'lib/core/data/customer/me'
import { useCoreContext } from '../useCoreContext'

interface Params {
  onSuccess?: () => void
  onError?: () => void
}

export const useUpdateDefaultBilling = (params?: Params) => {
  const { magentoClient, onError: handleError } = useCoreContext()
  const dispatch = useDispatch()
  const [isFetching, setIsFetching] = useState(false)

  const updateDefaultBilling = (customerAddressId: number, value: boolean) => {
    setIsFetching(true)
    return magentoClient?.customer.editCustomerAddress({
      id: customerAddressId,
      setDefaultBilling: value
    })
      .then(async () => {
        await dispatch(me())
        params?.onSuccess?.()
        setIsFetching(false)
      }).catch(e => {
        params?.onError?.()
        handleError?.(e)
        setIsFetching(false)
      })
  }

  return {
    isLoading: isFetching,
    updateDefaultBilling
  }
}
